export default __webpack_public_path__ + "assets/images/51104874155bc9eec219f988a8db5ee8.png";